import { t } from '@hefe/i18n';
import { RequestBasePostProspect } from '@hefe/models';
import { ProspectsApi } from '@hefe/store';
import dayjs from 'dayjs';
import CustomForm from '../../../core/components/form/custom-form';

export default function AddProspectForm() {
  const [createProspect, { isLoading: isCreatingProspect }] =
    ProspectsApi.useCreateProspectMutation();

  const submit = (values: any, resetFields: any) => {
    const submitValues: RequestBasePostProspect = {
      ...values,
      birthday: dayjs(values.birthday).format('YYYY-MM-DD'),
    };

    createProspect(submitValues)
      .unwrap()
      .then(() => {
        resetFields();
      })
      .catch(() => null);
  };

  const formId = `add-prospect-form`;
  return (
    <CustomForm
      key={formId}
      formId={formId}
      loading={isCreatingProspect}
      fields={[
        {
          name: 'sex',
          type: 'radiogroup',
          label: t('sex.title'),
          placeholder: t('sex.title'),
          selectOptions: [
            { label: t('sex.male'), value: 1 },
            { label: t('sex.female'), value: 2 },
            { label: t('sex.diverse'), value: 3 },
          ],
          rules: [
            {
              required: true,
              type: 'number',
              message: t('form_errors.sex'),
            },
          ],
        },
        {
          name: 'firstname',
          label: t('firstname'),
          type: 'text',
          rules: [
            {
              required: true,
              message: t('form_errors.name'),
            },
          ],
        },
        {
          name: 'lastname',
          label: t('lastname'),
          type: 'text',
          rules: [
            {
              required: true,
              message: t('form_errors.name'),
            },
          ],
        },
        {
          name: 'email',
          label: t('email'),
          type: 'email',
          rules: [
            {
              required: true,
              message: t('form_errors.email'),
            },
            {
              type: 'email',
              message: t('form_errors.email'),
            },
          ],
        },
        {
          name: 'phone',
          label: t('phone'),
          type: 'text',
          rules: [],
        },
        {
          name: 'birthday',
          label: t('birthday'),
          type: 'date',
          rules: [
            {
              required: true,
              message: t('form_errors.date'),
            },
          ],
        },
        {
          name: 'experience',
          type: 'radiogroup',
          label: t('prospects.experience.title'),
          placeholder: t('prospects.experience.title'),
          selectOptions: [
            ...['none', 'low', 'medium', 'high'].map((value) => ({
              label: t(`prospects.experience.${value}`),
              value,
            })),
          ],
          rules: [
            {
              required: true,
              type: 'string',
              message: t('form_errors.value'),
            },
          ],
        },
      ]}
      onSubmit={submit}
    />
  );
}
